import React, { useEffect, useState } from 'react';
import { Icon } from './icons.jsx';
import { USE_REAL_PLANS_API, planService, shouldUseMockTenants, tenantService } from './services.jsx';
// Planos e Permissões — módulo operacional avançado

const BACKEND_PLANS_DATA = [
  {
    id: 'basic', name: 'Basic', code: 'basic', status: 'ativo',
    routesCount: 45, tenantsCount: 82,
    monthlyPrice: 149, yearlyPrice: 1490, monthlyRevenue: 82 * 149,
    features: ['Pedidos', 'Produtos', 'Clientes', 'SEO básico', 'Frete', 'Pagamentos'],
    description: 'Plano de entrada com recursos essenciais para lojas em crescimento.',
    createdAt: '12 Jan 2024', updatedAt: 'Hoje, 09:30',
  },
  {
    id: 'pro', name: 'Pro', code: 'pro', status: 'ativo',
    routesCount: 46, tenantsCount: 37,
    monthlyPrice: 349, yearlyPrice: 3490, monthlyRevenue: 37 * 349,
    features: ['Tudo do Basic', 'Tabelas de Preço', 'App Store', 'SEO avançado', 'Blog', 'Relatórios avançados'],
    description: 'Recursos avançados para lojas com necessidades de personalização e escala.',
    createdAt: '12 Jan 2024', updatedAt: '18 Mai, 14:20',
  },
  {
    id: 'enterprise', name: 'Enterprise', code: 'enterprise', status: 'rascunho',
    routesCount: 60, tenantsCount: 0,
    monthlyPrice: 999, yearlyPrice: 9990, monthlyRevenue: 0,
    features: ['Tudo do Pro', 'API ilimitada', 'SLA dedicado', 'Multistore', 'White-label'],
    description: 'Solução corporativa com recursos ilimitados e suporte dedicado.',
    createdAt: '20 Mai 2026', updatedAt: '20 Mai 2026',
  },
];

const ROUTE_MODS = [
  { name: 'Pedidos', routes: [
    { name: 'Lista de pedidos',       path: '/dashboard/orders/',         plans: ['basic','pro','enterprise'] },
    { name: 'Detalhe do pedido',      path: '/dashboard/orders/:id/',     plans: ['basic','pro','enterprise'] },
    { name: 'Relatório de pedidos',   path: '/dashboard/orders/report/',  plans: ['pro','enterprise'] },
  ]},
  { name: 'Produtos', routes: [
    { name: 'Catálogo',               path: '/dashboard/catalogue/',              plans: ['basic','pro','enterprise'] },
    { name: 'Criar produto',          path: '/dashboard/catalogue/create/',       plans: ['basic','pro','enterprise'] },
    { name: 'Importação em massa',    path: '/dashboard/catalogue/import/',       plans: ['pro','enterprise'] },
  ]},
  { name: 'Clientes', routes: [
    { name: 'Lista de clientes',      path: '/dashboard/customers/',      plans: ['basic','pro','enterprise'] },
    { name: 'Detalhe do cliente',     path: '/dashboard/customers/:id/',  plans: ['basic','pro','enterprise'] },
    { name: 'Segmentos',              path: '/dashboard/customers/segments/', plans: ['pro','enterprise'] },
  ]},
  { name: 'Tabelas de Preço', routes: [
    { name: 'Tabelas de preço',       path: '/dashboard/price-tables/',        plans: ['pro','enterprise'] },
    { name: 'Criar tabela',           path: '/dashboard/price-tables/create/', plans: ['pro','enterprise'] },
  ]},
  { name: 'App Store', routes: [
    { name: 'App Store',              path: '/dashboard/apps/',           plans: ['pro','enterprise'] },
    { name: 'Instalar app',           path: '/dashboard/apps/install/',   plans: ['pro','enterprise'] },
  ]},
  { name: 'SEO', routes: [
    { name: 'SEO básico',             path: '/dashboard/seo/',            plans: ['basic','pro','enterprise'] },
    { name: 'SEO avançado',           path: '/dashboard/seo/advanced/',   plans: ['pro','enterprise'] },
    { name: 'Sitemap',                path: '/dashboard/seo/sitemap/',    plans: ['pro','enterprise'] },
  ]},
  { name: 'Blog', routes: [
    { name: 'Blog',                   path: '/dashboard/blog/',           plans: ['pro','enterprise'] },
    { name: 'Criar post',             path: '/dashboard/blog/create/',    plans: ['pro','enterprise'] },
  ]},
  { name: 'Relatórios', routes: [
    { name: 'Analytics',              path: '/dashboard/analytics/',      plans: ['basic','pro','enterprise'] },
    { name: 'Relatórios avançados',   path: '/dashboard/reports/',        plans: ['pro','enterprise'] },
    { name: 'Exportar dados',         path: '/dashboard/reports/export/', plans: ['enterprise'] },
  ]},
  { name: 'Configurações', routes: [
    { name: 'Configurações gerais',   path: '/dashboard/settings/',       plans: ['basic','pro','enterprise'] },
    { name: 'Domínios',               path: '/dashboard/settings/domains/', plans: ['basic','pro','enterprise'] },
    { name: 'Temas',                  path: '/dashboard/settings/themes/', plans: ['basic','pro','enterprise'] },
  ]},
];

const PLAN_TENANTS_DATA = [
  { id: 42,  name: 'Loja Exemplo Premium', schema: 'loja_exemplo_premium', status: 'ativo',                plan: 'pro',   owner: 'ana@lojaexemplo.com.br',   revenue: 349, activity: 'Há 2h' },
  { id: 103, name: 'Moda Clara',           schema: 'moda_clara',           status: 'falha_provisionamento', plan: 'pro',   owner: 'suporte@modaclara.com.br', revenue: 349, activity: 'Há 5 dias' },
  { id: 77,  name: 'Tech Store Brasil',    schema: 'tech_store_brasil',    status: 'inadimplente',          plan: 'basic', owner: 'carlos@techstore.com.br',  revenue: 149, activity: 'Há 3 dias' },
  { id: 8,   name: 'Moda Lis Atacado',     schema: 'moda_lis_atacado',     status: 'ativo',                 plan: 'basic', owner: 'camila@modalis.com.br',    revenue: 149, activity: 'Há 1h' },
  { id: 21,  name: 'Tech Quest Games',     schema: 'tech_quest_games',     status: 'ativo',                 plan: 'pro',   owner: 'edu@techquest.com.br',     revenue: 349, activity: 'Há 30min' },
];

const PLAN_LIMITS = [
  { name: 'Produtos',                basic: '500',       pro: 'Ilimitado', enterprise: 'Ilimitado' },
  { name: 'Usuários staff',          basic: '3',         pro: '10',        enterprise: 'Ilimitado' },
  { name: 'Domínios customizados',   basic: '1',         pro: '3',         enterprise: 'Ilimitado' },
  { name: 'Integrações',             basic: '2',         pro: '10',        enterprise: 'Ilimitado' },
  { name: 'Storage',                 basic: '5 GB',      pro: '50 GB',     enterprise: '500 GB' },
  { name: 'Requisições API/mês',     basic: '10k',       pro: '100k',      enterprise: 'Ilimitado' },
  { name: 'Tarefas agendadas',       basic: '—',         pro: '5',         enterprise: 'Ilimitado' },
  { name: 'Temas liberados',         basic: '3',         pro: '10',        enterprise: 'Ilimitado' },
  { name: 'Suporte incluído',        basic: 'E-mail',    pro: 'Chat + E-mail', enterprise: 'Dedicado' },
];

const fmtBRLPP = (v) => 'R$ ' + Math.round(v || 0).toLocaleString('pt-BR');

const PlanStatusBadge = ({ status }) => {
  const map = {
    ativo:         { label: 'Ativo',          cls: 'success' },
    rascunho:      { label: 'Rascunho',       cls: 'neutral' },
    depreciado:    { label: 'Depreciado',     cls: 'warning' },
    inconsistente: { label: 'Inconsistente',  cls: 'danger'  },
  };
  const c = map[status] || map.ativo;
  return <span className={`badge ${c.cls}`}><span className="dot" />{c.label}</span>;
};

const PPTabs = ({ tabs, active, onChange }) => (
  <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: 20 }}>
    {tabs.map(t => (
      <button key={t.id} onClick={() => onChange(t.id)} style={{
        padding: '9px 16px', border: 'none', background: 'transparent',
        fontSize: 13, fontWeight: active === t.id ? 600 : 500,
        color: active === t.id ? 'var(--text)' : 'var(--text-muted)',
        borderBottom: active === t.id ? '2px solid var(--brand-navy)' : '2px solid transparent',
        marginBottom: -1, cursor: 'pointer', transition: 'color 120ms',
      }}>{t.label}</button>
    ))}
  </div>
);

const ImpactModal = ({ open, plan, onClose, onConfirm }) => {
  const [motivo, setMotivo] = useState('');
  if (!open || !plan) return null;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(3px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 500, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden' }}>
        <div style={{ padding: '20px 22px 16px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--warning-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="alert" size={18} style={{ color: 'var(--warning)' }} /></div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 15 }}>Impacto da alteração — {plan.name}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>Análise de impacto antes de sincronizar</div>
            </div>
          </div>
        </div>
        <div style={{ padding: '16px 22px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          {[
            { label: 'Tenants afetados', value: plan.tenantsCount, icon: 'store' },
            { label: 'Roles a atualizar', value: Math.round(plan.tenantsCount * 1.8), icon: 'users' },
            { label: 'Rotas a reconfigurar', value: plan.routesCount, icon: 'link' },
          ].map(row => (
            <div key={row.label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: 'var(--bg-subtle)', borderRadius: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-secondary)' }}><Icon name={row.icon} size={14} />{row.label}</div>
              <strong style={{ fontSize: 14 }}>{row.value}</strong>
            </div>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: 'var(--warning-bg)', borderRadius: 8 }}>
            <Icon name="alert" size={14} style={{ color: 'var(--warning)' }} />
            <span style={{ fontSize: 13, color: 'var(--warning)', fontWeight: 500 }}>Risco: Médio — alterações de rota podem afetar usuários logados</span>
          </div>
          <div style={{ marginTop: 4 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Motivo da alteração <span style={{ color: 'var(--danger)' }}>*</span></label>
            <textarea value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Descreva o motivo técnico ou comercial desta alteração…" style={{ width: '100%', height: 72, padding: '8px 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', resize: 'none' }} />
          </div>
        </div>
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          <button className="btn" onClick={onClose}>Cancelar</button>
          <button className="btn primary" disabled={!motivo.trim()} onClick={() => { onConfirm(motivo); onClose(); }}>
            <Icon name="check" size={14} />Confirmar e sincronizar
          </button>
        </div>
      </div>
    </div>
  );
};

const PlanDetailDrawer = ({ plan, open, onClose, onToast, logAction }) => {
  const useRealPlans = typeof USE_REAL_PLANS_API !== 'undefined' && USE_REAL_PLANS_API;
  const [tab, setTab]     = useState('resumo');
  const [expanded, setExpanded] = useState({});
  const [impactOpen, setImpactOpen] = useState(false);

  if (!open || !plan) return null;

  const toggle = (n) => setExpanded(p => ({ ...p, [n]: !p[n] }));
  const TABS = [
    { id: 'resumo',   label: 'Resumo' },
    { id: 'rotas',    label: 'Rotas liberadas' },
    { id: 'limites',  label: 'Limites' },
    { id: 'tenants',  label: 'Tenants' },
    { id: 'historico',label: 'Histórico' },
  ].filter(t => !useRealPlans || (t.id !== 'tenants' && t.id !== 'historico'));

  const tenants = PLAN_TENANTS_DATA.filter(t => t.plan === plan.id);
  const activeTab = TABS.some(t => t.id === tab) ? tab : 'resumo';

  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      <div className="drawer" style={{ width: 640 }}>
        <div className="drawer-head">
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
              <h3 style={{ margin: 0 }}>{plan.name}</h3>
              <PlanStatusBadge status={plan.status} />
              <code style={{ fontSize: 11, background: 'var(--bg-subtle)', padding: '2px 8px', borderRadius: 5, color: 'var(--text-muted)', fontFamily: 'JetBrains Mono, monospace' }}>{plan.code}</code>
            </div>
            <div className="sub">{plan.tenantsCount} tenants · {plan.routesCount} rotas liberadas · {fmtBRLPP(plan.monthlyRevenue)}/mês</div>
          </div>
          <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>
        </div>

        <div style={{ padding: '0 22px', borderBottom: '1px solid var(--border)' }}>
          <PPTabs tabs={TABS} active={activeTab} onChange={setTab} />
        </div>

        <div className="drawer-body">
          {activeTab === 'resumo' && (
            <div>
              <div className="info-list">
                {[
                  ['Nome', plan.name],
                  ['Código técnico', <code style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>{plan.code}</code>],
                  ['Status', <PlanStatusBadge status={plan.status} />],
                  ['Preço mensal', fmtBRLPP(plan.monthlyPrice) + '/mês'],
                  ['Preço anual', fmtBRLPP(plan.yearlyPrice) + '/ano'],
                  ['Tenants usando', plan.tenantsCount],
                  ['Rotas liberadas', plan.routesCount],
                  ['Receita estimada', fmtBRLPP(plan.monthlyRevenue) + '/mês'],
                  ['Criado em', plan.createdAt],
                  ['Última alteração', plan.updatedAt],
                ].map(([l, v]) => (
                  <div key={l} className="info-row"><span className="label">{l}</span><span className="value">{v}</span></div>
                ))}
              </div>
              {plan.description && (
                <div style={{ marginTop: 14, padding: '12px 14px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5 }}>{plan.description}</div>
              )}
              <div style={{ marginTop: 14, display: 'flex', gap: 8 }}>
                {!useRealPlans && (
                  <button className="btn sm" disabled title="Fora do MVP" onClick={() => onToast && onToast('Sincronizar todos os tenants — fora do MVP (Fase 4).')}>
                    <Icon name="refresh" size={12} />Sincronizar tenants
                  </button>
                )}
                {!useRealPlans && (
                  <button className="btn sm" onClick={() => setImpactOpen(true)}>
                    <Icon name="zap" size={12} />Ver impacto
                  </button>
                )}
              </div>
            </div>
          )}

          {activeTab === 'rotas' && (
            <div>
              <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>{plan.routesCount} rotas liberadas · clique para expandir módulos</span>
                {!useRealPlans && (
                  <button className="btn sm" disabled title="Fora do MVP" onClick={() => onToast && onToast('Edição de rotas — fora do MVP (Fase 4).')}>
                    <Icon name="check" size={12} />Salvar alterações
                  </button>
                )}
              </div>
              {(plan.apiRoutes && plan.apiRoutes.length ? routesByModule(plan.apiRoutes) : ROUTE_MODS.filter(m => m.routes.some(r => r.plans.includes(plan.id)))).map(mod => {
                const modRoutes = plan.apiRoutes
                  ? mod.routes
                  : mod.routes.filter(r => r.plans.includes(plan.id));
                const isExp = expanded[mod.name] !== false;
                return (
                  <div key={mod.name} style={{ marginBottom: 8, border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
                    <div onClick={() => toggle(mod.name)} style={{ padding: '9px 14px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', background: 'var(--bg-subtle)', userSelect: 'none' }}>
                      <Icon name={isExp ? 'chevronDown' : 'chevronRight'} size={13} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
                      <strong style={{ fontSize: 13 }}>{mod.name}</strong>
                      <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{modRoutes.length} rotas</span>
                      <span style={{ marginLeft: 'auto', fontSize: 11, fontWeight: 600, background: modRoutes.length > 0 ? 'var(--success-bg)' : 'var(--bg-hover)', color: modRoutes.length > 0 ? 'var(--success)' : 'var(--text-muted)', padding: '2px 8px', borderRadius: 10 }}>
                        {modRoutes.length > 0 ? 'Liberado' : 'Bloqueado'}
                      </span>
                    </div>
                    {isExp && modRoutes.map(route => {
                      const enabled = plan.apiRoutes ? route.enabled !== false : route.plans?.includes(plan.id);
                      return (
                        <div key={route.path} style={{ padding: '8px 14px 8px 38px', display: 'flex', alignItems: 'center', gap: 10, borderTop: '1px solid var(--border)', opacity: enabled ? 1 : 0.5 }}>
                          <input type="checkbox" defaultChecked={enabled} disabled style={{ accentColor: 'var(--brand-navy)', width: 14, height: 14, flexShrink: 0 }} />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 13, color: 'var(--text)', fontWeight: 500 }}>{route.name}</div>
                            <code style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'JetBrains Mono, monospace' }}>{route.path}</code>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          )}

          {activeTab === 'limites' && (
            <div>
              <div style={{ marginBottom: 12, padding: '10px 14px', background: 'var(--info-bg)', borderRadius: 8, fontSize: 12, color: 'var(--info)', display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                <Icon name="alert" size={14} style={{ flexShrink: 0, marginTop: 1 }} />
                Limites são aplicados no momento de contratação. Alterações afetam novos tenants imediatamente e existentes na próxima sincronização.
              </div>
              <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 90px 90px 110px', padding: '8px 14px', background: 'var(--bg-subtle)', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', color: 'var(--text-muted)' }}>
                  <span>Recurso</span><span>Basic</span><span>Pro</span><span>Enterprise</span>
                </div>
                {PLAN_LIMITS.map((l, i) => (
                  <div key={l.name} style={{ display: 'grid', gridTemplateColumns: '1fr 90px 90px 110px', padding: '10px 14px', borderTop: '1px solid var(--border)', fontSize: 13 }}>
                    <span style={{ color: 'var(--text-secondary)' }}>{l.name}</span>
                    <span style={{ fontWeight: plan.id === 'basic' ? 700 : 400, color: plan.id === 'basic' ? 'var(--text)' : 'var(--text-muted)' }}>{l.basic}</span>
                    <span style={{ fontWeight: plan.id === 'pro' ? 700 : 400, color: plan.id === 'pro' ? 'var(--text)' : 'var(--text-muted)' }}>{l.pro}</span>
                    <span style={{ fontWeight: plan.id === 'enterprise' ? 700 : 400, color: plan.id === 'enterprise' ? 'var(--text)' : 'var(--text-muted)' }}>{l.enterprise}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {!useRealPlans && activeTab === 'tenants' && (
            <div>
              <div style={{ marginBottom: 12, fontSize: 13, color: 'var(--text-muted)' }}>{tenants.length} tenants neste plano</div>
              {tenants.length === 0 ? (
                <div className="hint-card"><Icon name="store" size={16} />Nenhum tenant neste plano ainda.</div>
              ) : (
                <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
                  <table className="data">
                    <thead><tr><th>Loja</th><th>Schema</th><th>Status</th><th>Receita</th><th style={{ textAlign: 'right' }}>Ações</th></tr></thead>
                    <tbody>
                      {tenants.map(t => (
                        <tr key={t.id}>
                          <td>
                            <div style={{ fontWeight: 500 }}>{t.name}</div>
                            <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{t.owner}</div>
                          </td>
                          <td><code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{t.schema}</code></td>
                          <td>
                            <span className={`badge ${t.status === 'ativo' ? 'success' : t.status === 'inadimplente' ? 'danger' : 'warning'}`}>
                              <span className="dot" />{t.status.replace('_', ' ')}
                            </span>
                          </td>
                          <td style={{ fontWeight: 500 }}>{fmtBRLPP(t.revenue)}</td>
                          <td>
                            <div className="row-actions">
                              <button className="icon-action" title="Cockpit"><Icon name="dashboard" size={13} /></button>
                              <button className="icon-action" title="Alterar plano"><Icon name="edit" size={13} /></button>
                              <button className="icon-action" title="Sincronizar"><Icon name="refresh" size={13} /></button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {!useRealPlans && activeTab === 'historico' && (
            <div className="timeline">
              {[
                { when: 'Hoje, 09:30',      event: 'Sincronização de permissões executada',          by: 'Ana Vargas · 177.142.12.8', kind: 'active' },
                { when: '18 Mai, 14:20',    event: `Rota /dashboard/price-tables/ adicionada ao ${plan.name}`, by: 'Pedro Chaves', kind: 'active' },
                { when: '03 Abr, 11:05',    event: 'Preço alterado: R$ 299 → R$ 349',               by: 'Julio Lazzaron · motivo: reajuste anual', kind: 'danger' },
                { when: '15 Jan 2024, 09:00', event: 'Plano criado',                                by: 'Julio Lazzaron', kind: 'active' },
              ].map((item, i) => (
                <div key={i} className="timeline-item">
                  <div className={`timeline-dot ${item.kind}`} />
                  <div className="timeline-body">
                    <div className="ev">{item.event}</div>
                    <div className="by">{item.when}<span className="dot-sep">·</span>{item.by}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="drawer-foot">
          <span className="note" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Icon name="lock" size={12} />Alterações são auditadas obrigatoriamente
          </span>
          <button className="btn" onClick={onClose}>Fechar</button>
          {!useRealPlans && activeTab === 'rotas' && (
            <button className="btn primary" onClick={() => setImpactOpen(true)}>
              <Icon name="zap" size={14} />Ver impacto & salvar
            </button>
          )}
        </div>
      </div>

      {!useRealPlans && (
        <ImpactModal
          open={impactOpen}
          plan={plan}
          onClose={() => setImpactOpen(false)}
          onConfirm={(motivo) => {
            onToast && onToast(`Permissões do plano ${plan.name} sincronizadas`);
            logAction && logAction({ acao: `Sincronizou plano ${plan.name} · motivo: ${motivo}`, loja: '—', kind: 'info' });
          }}
        />
      )}
    </>
  );
};

const routesByModule = (routes = []) => {
  const groups = {};
  routes.forEach(route => {
    const mod = route.module || 'dashboard';
    if (!groups[mod]) groups[mod] = [];
    groups[mod].push({
      name: route.label,
      path: route.path,
      enabled: route.enabled !== false,
    });
  });
  return Object.entries(groups).map(([name, modRoutes]) => ({ name, routes: modRoutes }));
};

const mapApiPlansToUi = (apiPlans, stores = []) => {
  return apiPlans
    .filter(p => p.code === 'basic' || p.code === 'pro')
    .map(p => {
      const fallback = BACKEND_PLANS_DATA.find(x => x.id === p.code) || {};
      const limits = p.limits || {};
      return {
        id: p.code,
        name: p.label || fallback.name || p.code,
        code: p.code,
        status: 'ativo',
        routesCount: p.routes_count || (p.routes || []).length,
        tenantsCount: (stores || []).filter(s => (s.plan?.id || s.plan) === p.code).length,
        monthlyPrice: fallback.monthlyPrice || 0,
        yearlyPrice: fallback.yearlyPrice || 0,
        monthlyRevenue: 0,
        features: fallback.features || [],
        description: fallback.description || '',
        createdAt: fallback.createdAt || '—',
        updatedAt: 'API',
        apiRoutes: p.routes || [],
        limits,
      };
    });
};

const TenantPermissionsSyncModal = ({ open, onClose, tenant, onToast, onSynced }) => {
  const [motivo, setMotivo] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) { setMotivo(''); setSaving(false); setError(null); }
  }, [open]);

  if (!open) return null;

  const tenantId = tenant?.tenant_id
    || (String(tenant?.id || '').startsWith('tenant_') ? String(tenant.id).replace('tenant_', '') : tenant?.id);

  const handleSync = async () => {
    if (!tenantId || motivo.trim().length < 5) return;
    setSaving(true);
    setError(null);
    try {
      const result = await tenantService.syncPermissions(tenantId, motivo.trim());
      onSynced && onSynced(result);
      onToast && onToast(`Permissões sincronizadas (${result.affected_roles || 0} role(s))`);
      onClose();
    } catch (e) {
      setError(e.message || 'Erro ao sincronizar permissões.');
      setSaving(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(3px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 480, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden' }}>
        <div style={{ padding: '20px 22px 16px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ fontWeight: 600, fontSize: 15 }}>Sincronizar permissões do tenant</div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
            {tenant?.name || 'Tenant'} · plano atual será reaplicado às roles
          </div>
        </div>
        <div style={{ padding: '16px 22px' }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Motivo <span style={{ color: 'var(--danger)' }}>*</span></label>
          <textarea value={motivo} onChange={e => setMotivo(e.target.value)} rows={3} placeholder="Mínimo 5 caracteres…" style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' }} />
          {error && <div style={{ marginTop: 10, fontSize: 12, color: 'var(--danger)' }}>{error}</div>}
        </div>
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn" onClick={onClose} disabled={saving}>Cancelar</button>
          <button className="btn primary" disabled={saving || motivo.trim().length < 5} onClick={handleSync}>
            {saving ? 'Sincronizando…' : 'Sincronizar'}
          </button>
        </div>
      </div>
    </div>
  );
};

const PlanosPermissoesPage = ({ onToast, stores, logAction, tenantContext }) => {
  const [plans,        setPlans]        = useState(() => (
    (typeof USE_REAL_PLANS_API !== 'undefined' && USE_REAL_PLANS_API)
      ? []
      : BACKEND_PLANS_DATA.filter(p => p.id !== 'enterprise')
  ));
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [drawerOpen,   setDrawerOpen]   = useState(false);
  const [plansLoading, setPlansLoading] = useState(true);
  const [plansError,   setPlansError]   = useState(null);
  const [schemaVersion,setSchemaVersion]= useState(window.__SA_PERMISSION_SCHEMA_VERSION__ || '—');
  const [tenantSyncOpen, setTenantSyncOpen] = useState(false);
  const [lastSync,      setLastSync]      = useState('—');

  const mvpDisabled = (feature) => () => onToast && onToast(`${feature} — fora do MVP (Fase 4).`);

  useEffect(() => {
    let cancelled = false;
    setPlansLoading(true);
    planService.listPlans()
      .then(data => {
        if (cancelled) return;
        setSchemaVersion(data.permission_schema_version || '—');
        const mapped = mapApiPlansToUi(data.results || [], stores);
        if (mapped.length) setPlans(mapped);
      })
      .catch((err) => {
        if (!cancelled) {
          const useReal = typeof USE_REAL_PLANS_API !== 'undefined' && USE_REAL_PLANS_API;
          if (useReal && !(typeof shouldUseMockTenants === 'function' && shouldUseMockTenants())) {
            setPlansError(err?.message || 'Não foi possível carregar planos da API.');
            setPlans([]);
          } else {
            setPlansError('Modo protótipo: exibindo planos mock Basic/Pro.');
            setPlans(BACKEND_PLANS_DATA.filter(p => p.id !== 'enterprise'));
          }
        }
      })
      .finally(() => { if (!cancelled) setPlansLoading(false); });
    return () => { cancelled = true; };
  }, [stores]);

  const openPlan = (plan) => { setSelectedPlan(plan); setDrawerOpen(true); };

  const totalRoutes = plans.reduce((sum, p) => sum + (p.routesCount || 0), 0);
  const basicCount = plans.find(p => p.id === 'basic')?.tenantsCount ?? 0;
  const proCount = plans.find(p => p.id === 'pro')?.tenantsCount ?? 0;

  const resolvedTenant = tenantContext ? (
    stores?.find(s => s.tenant_id === tenantContext.tenant_id || s.id === tenantContext.id) || tenantContext
  ) : null;

  const kpis = [
    { label: 'Planos ativos',         value: plans.length,    icon: 'layers',  sub: 'Basic + Pro' },
    { label: 'Tenants Basic',         value: basicCount,      icon: 'store',   sub: 'lista real' },
    { label: 'Tenants Pro',           value: proCount,        icon: 'store',   sub: 'lista real' },
    { label: 'Rotas controladas',     value: totalRoutes,     icon: 'link',    sub: `schema v${schemaVersion}` },
    { label: 'Última sincronização',  value: lastSync,        icon: 'refresh', small: true },
    { label: 'Inconsistências',       value: 0,               icon: 'check',   ok: true },
  ];

  return (
    <div className="content wide" style={{ maxWidth: 1200 }}>
      <div className="page-header">
        <div>
          <h1>Planos e Permissões</h1>
          <p className="sub">Gerencie planos, rotas liberadas, limites e impacto nos tenants.</p>
        </div>
        <div className="actions">
          {!(typeof USE_REAL_PLANS_API !== 'undefined' && USE_REAL_PLANS_API) && (
            <button className="btn" onClick={mvpDisabled('Histórico')}><Icon name="clock" size={14} />Histórico</button>
          )}
          <button
            className="btn"
            onClick={() => {
              if (!resolvedTenant) {
                onToast && onToast('Selecione um tenant (ex.: abra uma loja) para sincronizar permissões.');
                return;
              }
              setTenantSyncOpen(true);
            }}
          >
            <Icon name="refresh" size={14} />Sincronizar permissões
          </button>
          {!(typeof USE_REAL_PLANS_API !== 'undefined' && USE_REAL_PLANS_API) && (
            <>
              <button className="btn" onClick={mvpDisabled('Comparar planos avançado')}><Icon name="layers" size={14} />Comparar planos</button>
              <button className="btn primary" onClick={mvpDisabled('Novo plano')}><Icon name="plus" size={14} />Novo plano</button>
            </>
          )}
        </div>
      </div>

      {resolvedTenant && (
        <div style={{ marginBottom: 16, padding: '10px 14px', background: 'var(--info-bg)', borderRadius: 8, fontSize: 13, color: 'var(--info)', display: 'flex', alignItems: 'center', gap: 8 }}>
          <Icon name="store" size={14} />
          Tenant selecionado: <strong>{resolvedTenant.name}</strong> — sincronização aplicará apenas este tenant.
        </div>
      )}

      {!resolvedTenant && (
        <div style={{ marginBottom: 16, padding: '10px 14px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 13, color: 'var(--text-muted)' }}>
          Selecione um tenant para sincronizar permissões (navegue a partir do detalhe da loja ou cockpit).
        </div>
      )}

      {plansError && (
        <div style={{ marginBottom: 16, padding: '10px 14px', background: 'var(--warning-bg)', borderRadius: 8, fontSize: 13, color: 'var(--warning)' }}>{plansError}</div>
      )}

      {plansLoading && (
        <div style={{ marginBottom: 16, fontSize: 13, color: 'var(--text-muted)' }}>Carregando planos da API…</div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 12, marginBottom: 24 }}>
        {kpis.map(k => (
          <div key={k.label} className="kpi">
            <div className="label"><Icon name={k.icon} size={14} />{k.label}</div>
            <div className="value" style={{ fontSize: k.small ? 15 : 26, marginTop: 8 }}>{k.value}</div>
            {k.sub && <div className={`delta ${k.up ? 'up' : ''}`}>{k.up && <Icon name="trending" size={11} />}{k.sub}</div>}
            {k.ok && <div className="delta" style={{ color: 'var(--success)' }}><Icon name="check" size={11} />Nenhuma</div>}
          </div>
        ))}
      </div>

      <div className="table-wrap">
        <div className="table-toolbar">
          <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>Planos da plataforma</h3>
          <span style={{ fontSize: 12, color: 'var(--text-muted)', marginLeft: 8 }}>{plans.length} planos</span>
          <div style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 6 }}>
            <Icon name="server" size={13} />Schema permissões: <code style={{ fontFamily: 'JetBrains Mono, monospace' }}>v{schemaVersion}</code>
          </div>
        </div>
        <table className="data">
          <thead>
            <tr>
              <th>Plano</th><th>Código</th><th>Tenants</th><th>Rotas</th>
              <th>Features</th><th>Receita mensal</th><th>Status</th><th>Última alteração</th>
              <th style={{ textAlign: 'right' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {plans.map(plan => (
              <tr key={plan.id} style={{ cursor: 'pointer' }} onClick={() => openPlan(plan)}>
                <td>
                  <div style={{ fontWeight: 600 }}>{plan.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{plan.monthlyPrice > 0 ? fmtBRLPP(plan.monthlyPrice) + '/mês' : 'Preço a definir'}</div>
                </td>
                <td>
                  <code style={{ fontSize: 12, fontFamily: 'JetBrains Mono, monospace', background: 'var(--bg-subtle)', padding: '2px 8px', borderRadius: 5 }}>{plan.code}</code>
                </td>
                <td style={{ fontWeight: 600, fontSize: 16 }}>{plan.tenantsCount}</td>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 52, height: 5, background: 'var(--bg-subtle)', borderRadius: 3, overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: `${(plan.routesCount / 60) * 100}%`, background: 'var(--brand-navy)', borderRadius: 3 }} />
                    </div>
                    <span style={{ fontWeight: 500 }}>{plan.routesCount}</span>
                  </div>
                </td>
                <td>
                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                    {plan.features.slice(0, 2).map(f => (
                      <span key={f} style={{ fontSize: 11, background: 'var(--bg-subtle)', padding: '2px 7px', borderRadius: 4, color: 'var(--text-secondary)' }}>{f}</span>
                    ))}
                    {plan.features.length > 2 && <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>+{plan.features.length - 2}</span>}
                  </div>
                </td>
                <td style={{ fontWeight: 600 }}>{plan.monthlyRevenue > 0 ? fmtBRLPP(plan.monthlyRevenue) : '—'}</td>
                <td><PlanStatusBadge status={plan.status} /></td>
                <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>{plan.updatedAt}</td>
                <td onClick={e => e.stopPropagation()}>
                  <div className="row-actions">
                    <button className="icon-action" title="Ver detalhes" onClick={() => openPlan(plan)}><Icon name="arrowRight" size={13} /></button>
                    {!(typeof USE_REAL_PLANS_API !== 'undefined' && USE_REAL_PLANS_API) && (
                      <button className="icon-action" title="Sincronizar" onClick={() => { onToast && onToast(`Sincronizando ${plan.name}…`); }}><Icon name="refresh" size={13} /></button>
                    )}
                    <button className="icon-action" title="Editar" onClick={() => openPlan(plan)}><Icon name="edit" size={13} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <PlanDetailDrawer plan={selectedPlan} open={drawerOpen} onClose={() => setDrawerOpen(false)} onToast={onToast} logAction={logAction} />

      <TenantPermissionsSyncModal
        open={tenantSyncOpen}
        tenant={resolvedTenant}
        onClose={() => setTenantSyncOpen(false)}
        onToast={onToast}
        onSynced={(result) => {
          const ts = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
          setLastSync('Hoje ' + ts);
          logAction && logAction({
            acao: `Sincronizou permissões do tenant (${result.affected_roles || 0} roles)`,
            loja: resolvedTenant?.name || '—',
            lojaId: resolvedTenant?.id,
            kind: 'info',
          });
        }}
      />
    </div>
  );
};

export {
  PlanosPermissoesPage,
};
